module.exports = __webpack_public_path__ + "static/media/7.9b3c39dc.jpg";